module.exports = __webpack_public_path__ + "media/images/mirrorlake-8253438d2ca83e99f51e061a54bc72af.jpg";